import HolisticRubric from './HolisticRubric';

export default HolisticRubric;
